<section class="container">
  <div class="content-header">
    <h1>Jobs</h1>
    <button data-qa-id="jobs-btn-test-connection" (click)="startJob()">Test connection to Agent</button>
    @if (jobId) {
      <job-liveview [jobId]="jobId"></job-liveview>
    }
    <br />
    @if (checkComplete && result.length === 0) {
      <p>No Deployment Agents found</p>
    }
    <br />
    @if (checkComplete && result.length > 0) {
      <table data-qa-id="jobs-table-connection-results">
        <thead>
          <tr>
            <th>Machine Name</th>
            <th>OS</th>
            <th>Connection Successful?</th>
          </tr>
        </thead>
        <tbody>
          @for (connectionCheckResult of result; track connectionCheckResult) {
            <tr>
              <td>{{connectionCheckResult.MachineName}}</td>
              <td>{{connectionCheckResult.Os}}</td>
              <td>{{connectionCheckResult.ConnectionSuccessful}}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</section>